export default __webpack_public_path__ + "static/media/dining.f4e829f4.svg";